<template>
    <main>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">EXAMEN</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"></a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"></a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <indexExamenes :idHistoria="idHistoria" :finalizada="finalizada" :usuario="usuario" :id-tipo-historia="idTipoHistoria" :idUsuario="idUsuario"></indexExamenes>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            
        </div>
        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            
        </div>
        </div>
    
    </main>
    
</template>
<script>
import indexExamenes from "../base/baseReporteExamenesAdolescente/indexExamenes";
export default {
    props: ['idHistoria','finalizada','idUsuario', 'usuario','idTipoHistoria'],
    components:{indexExamenes},
}
</script>

